import i18n from '@/i18n'

export const quizStatus = {
    onGoing: {
        id: 2,
        value: i18n.t('moodPulse.statusOnGoing'),
    },
    paused: {
        id: 3,
        value: i18n.t('moodPulse.statusPaused'),
    },
    notStarted: {
        id: 1,
        value: i18n.t('moodPulse.statusNotStarted'),
    },
}

export const choices = [
    {
        id: 5,
        value: require('@/assets/images/mood-pulse/emoji/very-sad.png'),
    },
    {
        id: 4,
        value: require('@/assets/images/mood-pulse/emoji/sad.png'),
    },
    {
        id: 3,
        value: require('@/assets/images/mood-pulse/emoji/neutral.png'),
    },
    {
        id: 2,
        value: require('@/assets/images/mood-pulse/emoji/happy.png'),
    },
    {
        id: 1,
        value: require('@/assets/images/mood-pulse/emoji/very-happy.png'),
    },
]

export const getEmojiChoice = (id) =>
    choices.filter((choice) => choice.id === id)[0].value

export const getEmojiPerAverage = (average) => {
    if (average >= 1 && average < 2)
        return require('@/assets/images/mood-pulse/emoji/very-sad.png')

    if (average >= 2 && average < 3)
        return require('@/assets/images/mood-pulse/emoji/sad.png')

    if (average >= 3 && average < 4)
        return require('@/assets/images/mood-pulse/emoji/neutral.png')

    if (average >= 4 && average < 5)
        return require('@/assets/images/mood-pulse/emoji/happy.png')

    if (average === 5)
        return require('@/assets/images/mood-pulse/emoji/very-happy.png')
}

export const getTextPerDay = (average) => {
    if (average >= 1 && average < 2) return i18n.t('moodPulse.choices.verySad')

    if (average >= 2 && average < 3) return i18n.t('moodPulse.choices.sad')

    if (average >= 3 && average < 4) return i18n.t('moodPulse.choices.neutral')

    if (average >= 4 && average < 5) return i18n.t('moodPulse.choices.happy')

    if (average === 5) return i18n.t('moodPulse.choices.veryHappy')
}

export const graphTitle = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '21px',
    color: '#808080',
}
